import { getSoftwareProductNumber } from "./software";
import { getErrorSourceForErrorNumber } from "./errorSources";
export const createRequestData = ({ form, callId, softwares, selectedMachineTechnology, origin }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const formData = {
        callId,
        createdWith: "MyTRUMPF", // TODO: change to "MicroFrontend" when the backend is ready (this is validated in the backend)
        origin: origin || "", // e.g. "oseon" - this is not implemented on the backend yet
        notificationType: Number(form["notificationType"].value),
        description: form["description"].value,
        callBackContact: {
            salutation: Number(form["salutation"].value),
            firstName: form["firstName"].value,
            lastName: form["lastName"].value,
            phone: form["phone"].value,
            email: form["email"].value
        },
        equipmentNo: (_a = form["productNo"]) === null || _a === void 0 ? void 0 : _a.value,
        hmiErrorsWithInfo: Array.from(form.querySelectorAll("service-calls-dynamic-input input")).map((el) => ({
            errorNumber: el.value,
            errorSource: getErrorSourceForErrorNumber(el.value, selectedMachineTechnology)
        })),
        software: {
            productNumber: getSoftwareProductNumber(softwares, (_b = form["softwareType"]) === null || _b === void 0 ? void 0 : _b.value, (_c = form["softwareModule"]) === null || _c === void 0 ? void 0 : _c.value),
            softwareModule: (_d = form["softwareModule"]) === null || _d === void 0 ? void 0 : _d.value,
            softwareType: (_e = form["softwareType"]) === null || _e === void 0 ? void 0 : _e.value,
            isInstallationProblem: (_f = form["installationProblem"]) === null || _f === void 0 ? void 0 : _f.checked,
            isLicenseIssue: (_g = form["licenseIssue"]) === null || _g === void 0 ? void 0 : _g.checked,
            softwareProblemClassification: (_h = form["softwareProblemClassification"]) === null || _h === void 0 ? void 0 : _h.value
        },
        applicationTopicOptions: getApplicationOptions(form),
        purchaseOrderNumber: null, // there is no field in the form
        additionalText: null // there is no field in the form
    };
    return formData;
};
const getApplicationOptions = (form) => {
    var _a, _b, _c;
    const applicationOptions = [];
    if ((_a = form["application"]) === null || _a === void 0 ? void 0 : _a.value) {
        applicationOptions.push(form["application"].value);
    }
    if ((_b = form["optics"]) === null || _b === void 0 ? void 0 : _b.value) {
        applicationOptions.push(form["optics"].value);
    }
    if ((_c = form["applicationIssue"]) === null || _c === void 0 ? void 0 : _c.value) {
        applicationOptions.push(form["applicationIssue"].value);
    }
    return applicationOptions;
};
export const TRANSACTION_STATES = {
    RECEIVED: "Received" // other states tbd
};
//# sourceMappingURL=createCase.js.map
